<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card>
        <div class="data-title flex-space-between" slot="header">
          <p>Import Distro Tracks</p>
          <el-dropdown @command="setStatus">
              <span class="el-dropdown-link pointer">
                Status ({{ statuses[trackStatus] }}) <i class="el-icon-arrow-down el-icon--right" style="color: black !important"></i>
              </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">Incomplete</el-dropdown-item>
              <el-dropdown-item command="2">Submitted</el-dropdown-item>
              <el-dropdown-item command="3">Delivered</el-dropdown-item>
              <el-dropdown-item command="4">Rejected</el-dropdown-item>
              <el-dropdown-item command="5">Takedown</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div>
            <el-button v-if="getActions.includes('download')" type="primary" class="btn-main" @click="downloadTracks">
             Download Tracks
            </el-button>
            <el-button v-if="getActions.includes('publish')" type="primary" class="btn-main" @click="publishTracks">
              Publish Tracks
            </el-button>
            <el-button v-if="getActions.includes('distro')" type="primary" class="btn-main mr10" @click="distroSend">
              Send to Distro
            </el-button>
            <el-dropdown v-if="getActions.includes('status')" @command="bulkStatus">
              <el-button type="primary">
                Change Status<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu  slot="dropdown">
                <el-dropdown-item v-if="+trackStatus === 2" command="2">Approve</el-dropdown-item>
                <el-dropdown-item v-if="+trackStatus === 2" command="4">Reject</el-dropdown-item>
                <el-dropdown-item v-if="+trackStatus === 3" command="5">Takedown</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <el-table :data="tracks.data" class="w100 distro-import premium-table" stripe v-loading="loading">
          <el-table-column v-if="getColumns.includes('checkbox')" width="100">
            <template #header>
              <el-checkbox @change="selectAll" v-model="selectedAll" class="checkbox-track"></el-checkbox>
              <span> {{ totalSelected || 0 }}/{{ tracks.total || 0 }}</span>
            </template>
            <template #default="props">
              <el-checkbox :label="props.row.id" :value="props.row.id" v-model="selectedTracks" class="checkbox-track"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column v-if="getColumns.includes('cover')" label="Cover" width="140">
            <template slot-scope="props">
              <div class="cover-cell">
                <!-- Top badge or placeholder -->
                <div class="badge-top-container">
                  <el-tooltip v-if="props.row.ai && props.row.ai.is_ai_generated"
                              :content="`AI Confidence: ${props.row.ai.confidence}%`"
                              placement="top">
                    <div class="badge-item ai-badge-mini" @click="showAIAnalysis(props.row)">
                      <i class="el-icon-cpu"></i>
                      <span class="badge-number">{{ props.row.ai.confidence }}%</span>
                    </div>
                  </el-tooltip>
                  <div v-else class="badge-placeholder"></div>
                </div>

                <!-- Middle row with left badge, image, and right badge -->
                <div class="badge-middle-row">
                  <!-- Left badge or placeholder -->
                  <div class="badge-left-container">
                    <el-tooltip v-if="props.row.duplicates_count > 0"
                                :content="`${props.row.duplicates_count} duplicate${props.row.duplicates_count > 1 ? 's' : ''} found`"
                                placement="left">
                      <div class="badge-item duplicate-badge-mini" @click="showDuplicateDetails(props.row)">
                        <i class="el-icon-copy-document"></i>
                        <span class="badge-number">{{ props.row.duplicates_count }}</span>
                      </div>
                    </el-tooltip>
                    <div v-else class="badge-placeholder"></div>
                  </div>

                  <!-- Album cover -->
                  <img :src="host + '/' + props.row.album.artwork.path" class="avatar" alt="album_cover" />

                  <!-- Right badge or placeholder -->
                  <div class="badge-right-container">
                    <el-tooltip v-if="props.row.acr_cloud && (props.row.acr_cloud.music.length > 0 || props.row.acr_cloud.metadata.length > 0)"
                                :content="`ACRCloud: ${props.row.acr_cloud.music ? props.row.acr_cloud.music.length + ' matches' : 'Metadata found'}`"
                                placement="right">
                      <div class="badge-item acr-badge-mini" @click="showACRCloudDetails(props.row)">
                        <i class="el-icon-search"></i>
                        <span class="badge-number">{{ props.row.acr_cloud.music ? props.row.acr_cloud.music.length : 'M' }}</span>
                      </div>
                    </el-tooltip>
                    <div v-else class="badge-placeholder"></div>
                  </div>
                </div>

                <!-- Bottom badge or placeholder -->
                <div class="badge-bottom-container">
                  <el-tooltip v-if="props.row.cyanite" :content="`Cyanite`" placement="top">
                    <div class="badge-item cyanite-badge-mini" @click="showCyaniteDetails(props.row)">
                      <i class="el-icon-data-analysis"></i>
                    </div>
                  </el-tooltip>
                  <div v-else class="badge-placeholder"></div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="getColumns.includes('title')" label="Release Title" sortable>
            <template slot-scope="props">
              {{ props.row.album.release_title }}
            </template>
          </el-table-column>
          <el-table-column v-if="getColumns.includes('title')" label="Track Title" prop="title" sortable></el-table-column>
          <el-table-column v-if="getColumns.includes('account')" label="Account" sortable>
            <template slot-scope="props">
              {{ props.row.album.user ? props.row.album.user.email : '/' }}
            </template>
          </el-table-column>
          <el-table-column v-if="getColumns.includes('format')" label="Format" prop="format" sortable>
            <template slot-scope="props">
              <el-tag type="info"> {{ releaseFormat(props.row.album.release_format) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column v-if="getColumns.includes('tracks')" label="Tracks" prop="tracks" sortable>
            <template slot-scope="props">
              {{ props.row.album.tracks_count }}
            </template>
          </el-table-column>
          <el-table-column v-if="getColumns.includes('artist')" label="Main Artists" prop="artist" sortable>
            <template slot-scope="props">
              {{ props.row.album.artist ? props.row.album.artist.name : '/' }}
            </template>
          </el-table-column>
          <el-table-column v-if="getColumns.includes('isrc')" label="ISRC" prop="isrc_code" sortable></el-table-column>
          <el-table-column v-if="getColumns.includes('upc')" label="UPC" prop="upc" sortable>
            <template slot-scope="props">
              {{ props.row.album.upc_code }}
            </template>
          </el-table-column>
          <el-table-column v-if="getColumns.includes('created_at')" label="Uploaded_at" sortable>
            <template slot-scope="props">
              {{ moment(props.row.created_at).format('DD MMM YYYY') }}
            </template>
          </el-table-column>
          <el-table-column v-if="getColumns.includes('status')" label="Status" sortable>
            <template slot-scope="props">
              <el-tag v-if="props.row.status === 1" type="warning">Pending</el-tag>
              <el-tag v-else-if="props.row.status === 2" type="success">Approved</el-tag>
              <el-tag v-else-if="props.row.status === 4" type="error">Rejected</el-tag>
            </template>
          </el-table-column>
          <el-table-column v-if="getColumns.includes('distro')" label="Distro" sortable>
            <template slot-scope="props">
              <el-tag v-if="props.row.send_to_distro === 0" type="warning">None</el-tag>
              <el-tag v-else-if="props.row.send_to_distro === 1" type="info">Processing</el-tag>
              <el-tag v-else-if="props.row.send_to_distro === 2" type="success">Done</el-tag>
            </template>
          </el-table-column>
          <el-table-column v-if="getColumns.includes('actions')" label="Actions" align="right" width="240">
            <template slot-scope="props">
              <el-tooltip content="Play Track" placement="top">
                <el-button type="primary" circle size="small" icon="el-icon-video-play" @click="openTrackPlayer(props.row)" class="mr10"></el-button>
              </el-tooltip>
              <el-tooltip v-if="getActions.includes('status')" content="Status" placement="top">
                <el-popover placement="left" trigger="click" width="300">
                  <el-button slot="reference" class="mr10"
                             circle size="small" icon="el-icon-check"></el-button>
                  <div class="video-status">
                    <p class="m0">Edit status for track <b>{{ props.row.title }}</b></p>
                    <el-radio-group class="mt10" v-model="props.row.status" size="small"
                                    @change="changeTrackStatus($event, props.row.id)">
                      <el-radio-button :label="2">Approve{{ props.row.approved === 2 ? 'd' : ''}}</el-radio-button>
                      <el-radio-button :label="4">Reject{{ props.row.approved === 4 ? 'ed' : ''}}</el-radio-button>
                    </el-radio-group>
                  </div>
                </el-popover>
              </el-tooltip>
              <el-tooltip v-if="getActions.includes('edit')" content="Edit" placement="top">
                <el-button type="warning" circle size="small" icon="el-icon-edit" @click="openModal(props.row)"></el-button>
              </el-tooltip>
              <el-tooltip v-if="getActions.includes('takedown')" content="Takedown" placement="top">
                <el-button circle size="small" icon="el-icon-warning" @click="changeTrackStatus(5, props.row.id)"></el-button>
              </el-tooltip>
              <el-tooltip v-if="getActions.includes('delete')" content="Delete" placement="top">
                <el-button type="danger" circle size="small" @click="deleteTrack(props.row.id)" icon="el-icon-close"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination style="width: 700px; margin: auto"
                       background @size-change="sizeChange" @current-change="currentChange"
                       :current-page="tracks.current_page" :page-sizes="[10, 25, 50]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="tracks.total"
        ></el-pagination>

        </el-card>
      </el-col>
    </el-row>

    <!-- AI Analysis Modal -->
  <AIAnalysisModal
    :visible.sync="aiModalVisible"
    :track="currentTrack" />


  <!-- Duplicate Details Modal -->
  <DuplicateDetailsModal
    :visible.sync="duplicateModalVisible"
    :track="currentTrack"
    :audio-source="audioSource"
    ref="duplicateModal" />

  <!-- Track Player Modal -->
  <TrackPlayerModal
    :visible.sync="playerModalVisible"
    :track="currentTrack"
    :audio-source="audioSource"
    :host="host" />

  <!-- ACRCloud Details Modal -->
  <ACRCloudModal
    :visible.sync="acrModalVisible"
    :track="currentTrack" />

  <!-- Cyanite Modal -->
  <CyaniteModal
    :visible.sync="cyaniteModalVisible"
    :track="currentTrack" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import moment from "moment";
import AIAnalysisModal from "./AIAnalysisModal.vue";
import DuplicateDetailsModal from "./DuplicateDetailsModal.vue";
import ACRCloudModal from "./ACRCloudModal.vue";
import TrackPlayerModal from "./TrackPlayerModal.vue";
import CyaniteModal from "./CyaniteModal.vue";

export default {
  components: {
    AIAnalysisModal,
    DuplicateDetailsModal,
    ACRCloudModal,
    TrackPlayerModal,
    CyaniteModal
  },

  data() {
    return {
      statuses: { '1': 'Incomplete', '2': 'Submitted', '3': 'Delivered', '4': 'Rejected', '5': 'Takedown' },
      moment,
      selectedTracks: [],
      selectedAll: false,
      host: process.env.VUE_APP_API_HOST,
      aiModalVisible: false,
      duplicateModalVisible: false,
      playerModalVisible: false,
      acrModalVisible: false,
      cyaniteModalVisible: false,
      currentTrack: null,
      audioSource: ''
    }
  },

  computed: {
    ...mapState('distro', ['trackStatus', 'pageSize', 'currentPage', 'tracks', 'loading', 'assets']),
    ...mapGetters('distro', ['getColumns', 'getActions']),

    totalSelected() {
      if (this.selectedAll && this.selectedTracks.length === this.tracks.data.length) {
        return this.tracks.total
      }
      else if (this.selectedAll && this.selectedTracks.length !== this.tracks.data.length) {
        return this.tracks.total - (this.tracks.data.length - this.selectedTracks.length)
      }
      else return this.selectedTracks.length
    },

  },

  methods: {
    ...mapMutations('distro', ['setTrackStatus', 'setPageSize', 'setCurrentPage', 'setShowDialog', 'setTrack']),
    ...mapActions('distro', [
        'getTracks', 'changeStatus', 'sendToDistro', 'deleteTrack', 'download', 'staticAssets', 'publish',
        'bulkChangeStatus'
    ]),

    async setStatus(status) {
      this.setCurrentPage(1)
      this.setTrackStatus(status)
      await this.getTracks()
    },

    releaseFormat(id) {
      const find = this.assets.releaseFormat.find(_ => _.id === id)
      return find ? find.name : id
    },

    async sizeChange(size) {
      this.setPageSize(size)
      await this.getTracks()
    },

    async currentChange(page) {
      this.setCurrentPage(page)
      await this.getTracks()
    },

    async changeTrackStatus(status, trackId) {
      await this.changeStatus({ status, trackId })
    },

    selectAll(value) {
      this.selectedAll = value
      if (value) this.selectedTracks = [...this.tracks.data.map(_ => _.id)]
      else this.selectedTracks = []
    },

    async distroSend() {
      const ids = this.totalSelected === this.tracks.total ? ['*'] : this.selectedTracks;
      await this.sendToDistro(ids)
      this.resetCheckboxes()
    },

    async publishTracks() {
      const ids = this.totalSelected === this.tracks.total ? ['*'] : this.selectedTracks;
      await this.publish(ids)
      this.resetCheckboxes()
    },

    async downloadTracks() {
      const ids = this.totalSelected === this.tracks.total ? '*' : this.selectedTracks.join(',');
      await this.download(ids)
      this.resetCheckboxes()
    },

    openModal(track) {
      this.setTrack(JSON.parse(JSON.stringify(track)))
      this.setShowDialog(true)
    },

    async bulkStatus(value) {
      const ids = this.totalSelected === this.tracks.total ? ['*'] : this.selectedTracks;

      await this.bulkChangeStatus({ ids, status: value })
      this.resetCheckboxes()
    },

    resetCheckboxes() {
      this.selectedAll = false
      this.selectedTracks = []
    },

    showAIAnalysis(track) {
      this.currentTrack = track
      this.aiModalVisible = true
    },

    showDuplicateDetails(track) {
      this.currentTrack = track
      this.duplicateModalVisible = true

      // Set audio source from track wav file
      if (track.track_file) {
        this.audioSource = this.host + '/' + track.track_file.path
      }
    },

    openTrackPlayer(track) {
      this.currentTrack = track
      this.playerModalVisible = true

      // Set audio source from track wav file
      if (track.track_file) {
        this.audioSource = this.host + '/' + track.track_file.path
      }
    },

    showACRCloudDetails(track) {
      this.currentTrack = track
      this.acrModalVisible = true
    },

    showCyaniteDetails(track) {
      this.currentTrack = track
      this.cyaniteModalVisible = true
    }
  },

  async created() {
    await this.staticAssets()
    await this.getTracks()
  }
}
</script>

<style lang="scss">
.distro-import .checkbox-track span {
  width: 20px;
  height: 20px;
  border-color: #e55279;
}

.checkbox-track .el-checkbox__label {
  display: none;
}

.el-checkbox__inner::after {
  height: 10px;
  left: 7px;
}

.distro-import .checkbox-track {
  display: flex;
}

// Premium Table Styles
.premium-table {
  .cover-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
    position: relative;
    padding: 8px 0;

    .avatar {
      width: 50px;
      height: 50px;
      object-fit: cover;
      border-radius: 100%;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      margin: 3px 0;
    }

    .badge-middle-row {
      display: flex;
      align-items: center;
      gap: 3px;
      position: relative;
    }

    .badge-top-container,
    .badge-bottom-container {
      height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 2px 0;
    }

    .badge-left-container,
    .badge-right-container {
      width: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .badge-placeholder {
      width: 22px;
      height: 22px;
      visibility: hidden;
    }
  }

  .ai-badge,
  .duplicate-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: uppercase;
    letter-spacing: 0.5px;

    i {
      font-size: 14px;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }

  .ai-badge {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;

    &:hover {
      background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
    }
  }

  .duplicate-badge {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    color: white;

    &:hover {
      background: linear-gradient(135deg, #f5576c 0%, #f093fb 100%);
    }
  }

  // Unified mini badges for cover column
  .badge-item {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 22px;
    min-width: 22px;
    padding: 0 6px;
    border-radius: 11px;
    font-size: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    gap: 3px;
    white-space: nowrap;

    i {
      font-size: 11px;
      flex-shrink: 0;
    }

    .badge-number {
      font-size: 9px;
      font-weight: 700;
      line-height: 1;
    }

    &:hover {
      transform: translateX(1px);
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
    }
  }

  .ai-badge-mini {
    background: linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%);
    color: white;

    &:hover {
      background: linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%);
    }
  }

  .duplicate-badge-mini {
    background: linear-gradient(135deg, #ec4899 0%, #f472b6 100%);
    color: white;

    &:hover {
      background: linear-gradient(135deg, #db2777 0%, #ec4899 100%);
    }
  }

  .acr-badge-mini {
    background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
    color: white;

    &:hover {
      background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
    }
  }

  .cyanite-badge-mini {
    background: linear-gradient(135deg, #48c774 0%, #3ec46d 100%);
    color: white;

    &:hover {
      background: linear-gradient(135deg, #3ec46d 0%, #48c774 100%);
      transform: scale(1.05);
    }
  }
}

// Premium Modal Styles
.premium-modal {
  .el-dialog__header {
    background: linear-gradient(135deg, #e55279 0%, #9b6dbb 100%);
    padding: 20px;

    .el-dialog__title {
      color: white;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__close {
      color: white;
      font-size: 20px;

      &:hover {
        color: #f0f0f0;
      }
    }
  }

  .el-dialog__body {
    padding: 30px;
  }
}

// AI Modal Specific Styles
.ai-modal {
  .ai-analysis-content {
    .ai-confidence-meter {
      margin-bottom: 30px;

      .meter-label {
        font-size: 14px;
        color: #666;
        margin-bottom: 10px;
        text-transform: uppercase;
        letter-spacing: 1px;
        font-weight: 600;
      }

      .meter-container {
        height: 40px;
        background: #f0f2f5;
        border-radius: 20px;
        overflow: hidden;
        position: relative;
        box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);

        .meter-fill {
          height: 100%;
          background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-right: 15px;
          transition: width 0.5s ease;

          .meter-value {
            color: white;
            font-weight: bold;
            font-size: 14px;
          }
        }
      }

      .meter-scale {
        display: flex;
        justify-content: space-between;
        margin-top: 5px;
        font-size: 11px;
        color: #999;
      }
    }

    .ai-status {
      padding: 20px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 25px;

      i {
        font-size: 24px;
      }

      span {
        font-size: 16px;
        font-weight: 600;
      }

      &.ai-detected {
        background: linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%);
        border: 2px solid #ff6b6b;
        color: #c92a2a;
      }

      &.human-created {
        background: linear-gradient(135deg, #f0fff4 0%, #d3f9d8 100%);
        border: 2px solid #51cf66;
        color: #2b8a3e;
      }
    }

    .analysis-details {
      background: #f8f9fa;
      padding: 20px;
      border-radius: 12px;

      h4 {
        margin: 0 0 15px 0;
        color: #495057;
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 1px;
      }

      p {
        margin: 0;
        color: #666;
        line-height: 1.8;
        font-size: 14px;
      }
    }
  }
}

// Duplicate Modal Specific Styles
.duplicate-modal {
  .duplicate-content {
    .duplicate-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 25px;
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      border-radius: 12px;
      margin-bottom: 30px;

      .original-track,
      .duplicate-track {
        text-align: center;

        h4 {
          margin: 0 0 10px 0;
          color: #495057;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        p {
          margin: 0 0 5px 0;
          font-weight: 600;
          color: #212529;
          font-size: 16px;
        }

        small {
          color: #868e96;
          font-size: 11px;
        }
      }

      .similarity-indicator {
        text-align: center;

        .similarity-circle {
          width: 110px;
          height: 110px;
          position: relative;
          margin: 0 auto 10px;

          .circular-chart {
            display: block;
            margin: 0 auto;
            max-width: 100%;
            max-height: 110px;
          }

          .circle-bg {
            stroke: #f0f2f5;
          }

          .circle {
            stroke: #f093fb;
            stroke-linecap: round;
            animation: progress 1s ease-out forwards;
          }

          .percentage {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 18px;
            font-weight: bold;
            color: #667eea;
            white-space: nowrap;
          }
        }

        p {
          margin: 0;
          font-size: 12px;
          color: #868e96;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
      }
    }

    .segments-section {
      margin-bottom: 30px;

      h4 {
        margin: 0 0 20px 0;
        color: #495057;
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 1px;
      }

      .segments-timeline {
        display: flex;
        gap: 15px;
        flex-wrap: wrap;

        .segment-item {
          background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
          color: white;
          padding: 12px 20px;
          border-radius: 25px;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 8px;

          .segment-bar {
            display: flex;
            align-items: center;

            i {
              font-size: 16px;
            }
          }

          span {
            font-weight: 600;
            font-size: 14px;
          }

          &:hover,
          &.active {
            transform: translateY(-3px);
            box-shadow: 0 6px 20px rgba(245, 87, 108, 0.4);
          }

          &.active {
            background: linear-gradient(135deg, #f5576c 0%, #f093fb 100%);
          }
        }
      }
    }

    .player-section {
      background: #f8f9fa;
      padding: 25px;
      border-radius: 12px;

      h4 {
        margin: 0 0 20px 0;
        color: #495057;
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 1px;
      }

      .player-controls {
        margin-bottom: 20px;

        .el-button {
          padding: 12px 24px;
          font-weight: 600;

          i {
            margin-right: 5px;
          }
        }
      }

      .segment-highlight {
        margin-top: 15px;
        text-align: center;

        .el-tag {
          padding: 8px 16px;
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
  }
}

// Track Player Modal Styles
.player-modal {
  .track-player-content {
    .track-info {
      display: flex;
      gap: 25px;
      margin-bottom: 30px;
      padding: 25px;
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      border-radius: 12px;

      .track-artwork {
        width: 120px;
        height: 120px;
        object-fit: cover;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }

      .track-details {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

        h3 {
          margin: 0 0 10px 0;
          font-size: 24px;
          color: #212529;
        }

        p {
          margin: 0 0 5px 0;
          color: #666;
          font-size: 14px;

          &.track-meta {
            color: #868e96;
            font-size: 12px;
            margin-top: 10px;
          }
        }
      }
    }

    .audio-player-wrapper {
      margin-bottom: 25px;

      audio {
        width: 100%;
        outline: none;

        &::-webkit-media-controls-panel {
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        }
      }
    }

    .track-indicators {
      display: flex;
      gap: 10px;
      justify-content: center;

      .el-tag {
        font-weight: 600;

        i {
          margin-right: 5px;
        }
      }
    }
  }
}

// ACRCloud Modal Styles
.acr-modal {
  .acr-content {
    .music-matches-section {
      margin-bottom: 30px;

      h3 {
        color: #495057;
        font-size: 16px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        gap: 8px;

        i {
          color: #4facfe;
        }
      }

      .matches-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
        gap: 20px;

        .match-card {
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
          border: 1px solid #e9ecef;
          border-radius: 12px;
          padding: 20px;
          display: flex;
          gap: 20px;
          transition: all 0.3s ease;

          &:hover {
            box-shadow: 0 8px 24px rgba(79, 172, 254, 0.1);
            transform: translateY(-2px);
          }

          .match-score {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 8px;

            .score-circle {
              width: 70px;
              height: 70px;
              border-radius: 50%;
              background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
              display: flex;
              align-items: center;
              justify-content: center;
              color: white;
              font-weight: bold;
              font-size: 18px;
              box-shadow: 0 4px 12px rgba(79, 172, 254, 0.3);
            }

            .match-label {
              font-size: 11px;
              color: #868e96;
              text-transform: uppercase;
              letter-spacing: 0.5px;
            }
          }

          .match-details {
            flex: 1;

            .detail-row {
              display: flex;
              margin-bottom: 8px;
              font-size: 13px;

              .label {
                color: #868e96;
                width: 100px;
                flex-shrink: 0;
              }

              .value {
                color: #495057;
                font-weight: 500;

                &.code {
                  font-family: monospace;
                  background: #f1f3f5;
                  padding: 2px 6px;
                  border-radius: 4px;
                }
              }
            }
          }
        }
      }
    }

    .metadata-section {
      margin-bottom: 30px;

      h3 {
        color: #495057;
        font-size: 16px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        gap: 8px;

        i {
          color: #00f2fe;
        }
      }

      .metadata-card {
        background: #f8f9fa;
        border-radius: 12px;
        padding: 20px;
        display: flex;
        gap: 20px;

        .meta-image {
          img {
            width: 100px;
            height: 100px;
            object-fit: cover;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          }
        }

        .streaming-links {
          flex: 1;

          .link-group {
            margin-bottom: 15px;
            display: flex;
            align-items: center;
            gap: 10px;
            flex-wrap: wrap;

            .platform-badge {
              padding: 6px 12px;
              border-radius: 20px;
              font-size: 12px;
              font-weight: 600;
              color: white;
              display: inline-flex;
              align-items: center;
              gap: 5px;

              &.spotify {
                background: linear-gradient(135deg, #1db954 0%, #1ed760 100%);
              }

              &.apple {
                background: linear-gradient(135deg, #fc3c44 0%, #fa233b 100%);
              }

              &.deezer {
                background: linear-gradient(135deg, #ff6d00 0%, #ff9100 100%);
              }

              &.youtube {
                background: linear-gradient(135deg, #ff0000 0%, #cc0000 100%);
              }
            }

            .stream-link {
              color: #4facfe;
              text-decoration: none;
              font-size: 13px;
              padding: 4px 8px;
              border: 1px solid #4facfe;
              border-radius: 16px;
              transition: all 0.3s ease;

              &:hover {
                background: #4facfe;
                color: white;
              }
            }
          }
        }
      }
    }

    .analysis-section {
      background: linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%);
      border-radius: 12px;
      padding: 20px;
      border: 1px solid #ffb3b3;

      h3 {
        color: #c92a2a;
        font-size: 16px;
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        gap: 8px;

        i {
          color: #fa5252;
        }
      }

      .analysis-list {
        .analysis-item {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 10px;
          padding: 10px;
          background: white;
          border-radius: 8px;
          font-size: 14px;
          color: #495057;

          i {
            flex-shrink: 0;

            &.error {
              color: #fa5252;
            }

            &.warning {
              color: #fd7e14;
            }
          }
        }
      }
    }

    .no-data {
      text-align: center;
      padding: 40px;
      color: #868e96;

      i {
        font-size: 48px;
        color: #dee2e6;
        margin-bottom: 15px;
      }

      p {
        margin: 0;
        font-size: 14px;
      }
    }
  }
}

// Gradient Definition
@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}
</style>